import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import {
  ViewConsentsHistoryCallbackInput,
  ViewConsentsHistoryDialog,
  ViewConsentsHistoryDialogUniqueProps,
} from '../ViewConsentsHistoryDialog';

const { useDialogForContext, useDialog: useViewConsentsHistoryDialog } =
  getDialogHooks<
    ViewConsentsHistoryDialogUniqueProps,
    ViewConsentsHistoryCallbackInput
  >(ViewConsentsHistoryDialog);
export const useViewConsentsHistoryDialogForContenxt = useDialogForContext;
export default useViewConsentsHistoryDialog;
